import { useCallback, useEffect, useRef, useState } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const knownHash = useRef<string | null>(null);

  const checkVersion = useCallback(async () => {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-store'
      });
      if (!response.ok) return;
      const data = await response.json();

      if (!knownHash.current) {
        // First check — store the current version
        knownHash.current = data.hash;
        return;
      }

      if (data.hash !== knownHash.current) {
        setUpdateAvailable(true);
      }
    } catch {
      // Silently fail — version check is best-effort
    }
  }, []);

  const handleRefresh = useCallback(() => {
    window.location.reload();
  }, []);

  const handleDismiss = useCallback(() => {
    setUpdateAvailable(false);
  }, []);

  useEffect(() => {
    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [checkVersion]);

  return { handleDismiss, handleRefresh, updateAvailable };
};

export default useVersionCheck;
